<script lang="ts">
    import Fa from 'svelte-fa'
    import { faEdit, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
    import { Category } from '../../modules/prospectApi/categories/category'
    import { CategoriesRepository } from '../../modules/prospectApi/categories/categories.repository'
    import { CategoriesService } from '../../modules/prospectApi/categories/categories.service'
    import { onMount } from 'svelte'

    export let category: Category = null
    export let categoryId: String = null
    export let disabled: boolean = false
    export let small = false
    export let label = ''

    const categoryR = new CategoriesRepository()
    const categoryS = new CategoriesService(categoryR)
    let query = ''
    let categories: Category[] = []

    let delay = null
    async function search(query) {
        if (!_showDrop) return
        if (delay) clearInterval(delay)
        delay = setTimeout(async () => {
            categories = await categoryS.getAll({ query })
            if (categories.length === 0) dropHelper = 'Não encontrado. Verifique a grafia. Utilize acentos.'
        }, 500)
    }

    function select(index) {
        category = categories[index]
        categoryId = category.categoryId
        query = ''
        categories = []
    }

    async function loadCategory(categoryId) {
        if (categoryId) {
            category = await categoryS.getOne(categoryId)
            _showDrop = false
        }
    }

    function friendlyName(p: Category) {
        let str = p.name
        return str
    }

    function clear() {
        categoryId = null
        category = null
        categoryId = null
        _showDrop = false
    }

    let showForm = false
    function newCategory() {
        category = new Category()
        showForm = true
    }

    function hideForm(event) {
        showForm = false
        if (event.detail?.categoryId) {
            category = event.detail
        }
    }

    let _showDrop = false
    let dropHelper = 'Digite ao menos 3 caracteres para pesquisar...'
    function showDrop(event) {
        _showDrop = true
        search('')
    }

    function hideDrop(event) {
        setTimeout(() => {
            _showDrop = false
        }, 300)
    }

    onMount(() => {
        if (category?.categoryId && !category?.createdAt) categoryId = category.categoryId
        loadCategory(categoryId)
    })

    $: {
        search(query)
    }
</script>

<div class="query">
    <div class="input-group" class:input-group-sm={small === true}>
        {#if label}
            <div class="input-group-text">{label}</div>
        {/if}
        {#if category && category.categoryId}
            <input
                class="form-control"
                class:form-control-sm={small === true}
                disabled
                value={friendlyName(category)}
                type="text"
            />
            {#if !disabled}
                <button class="btn btn-secondary" class:form-control-sm={small === true} on:click={clear}
                    ><Fa icon={faTimes} /></button
                >
            {/if}
        {:else}
            <input
                class="form-control select-icon"
                class:form-control-sm={small === true}
                type="text"
                bind:value={query}
                on:focus={showDrop}
                on:blur={hideDrop}
            />
        {/if}
    </div>

    {#if _showDrop}
        <div class="list">
            {#if categories.length === 0 && !!query}
                <div class="list-helper p-2 text-muted">{dropHelper}</div>
            {:else}
                {#each categories as p, index}
                    <button
                        on:click={() => {
                            select(index)
                        }}>{friendlyName(p)}</button
                    >
                {/each}
            {/if}
        </div>
    {/if}
</div>

<style>
    .list-helper {
        color: #333;
        background-color: #eee;
    }
    .query {
        position: relative;
        flex-grow: 1;
        width: 100%;
    }
    .list {
        display: flex;
        flex-direction: column;
        box-shadow: 4px 3px 6px #111;
        position: absolute;
        flex-grow: 1;
        z-index: 5;
        width: 100%;
        overflow-y: auto;
        max-height: 50vh;
    }
    .list button {
        flex-grow: 1;
        padding: 8px;
        text-align: left;
    }
    .list button:hover {
        background-color: #ddd;
    }
</style>
